import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { PendoAccessService } from '@capital-access/common/auth';

export const pendoNavigationGuard: CanActivateFn = () => {
  const pendoAccessService = inject(PendoAccessService);
  const router = inject(Router);

  return pendoAccessService.checkAccess().pipe(
    take(1),
    map(({ shouldHidePendo }) => {
      if (shouldHidePendo) {
        router.navigate(['/']);
        return false;
      }
      return true;
    })
  );
};
